import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { apiConfigured, env } from "../lib/env";

/** Operator view. Preserved from the original admin page. */
export function Health() {
  const [result, setResult] = useState<{ status: number; body: Record<string, string> } | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .health()
      .then(setResult)
      .catch((e: unknown) => setError(String(e)));
  }, []);

  return (
    <section className="stack">
      <div>
        <h1>Service health</h1>
        <p className="lede">
          API base: <span className="mono">{apiConfigured ? env.apiBase : "not configured"}</span>
        </p>
      </div>
      {error && <pre style={{ color: "var(--danger)" }}>{error}</pre>}
      {result && (
        <div className="card">
          <dl className="kv">
            <dt>HTTP</dt>
            <dd>{result.status}</dd>
            {Object.entries(result.body).map(([k, v]) => (
              <>
                <dt key={`${k}-k`}>{k}</dt>
                <dd key={`${k}-v`}>{String(v)}</dd>
              </>
            ))}
          </dl>
        </div>
      )}
    </section>
  );
}
